<template>
  <div>
    <div>
      <div align="left"></div>
    </div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Paxel Market - Join Procedure</h5>
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <router-link :to="{name: 'createPaxelMarketJoinProcedure'}">
            <b-button variant="primary">
              <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        responsive
        show-empty
        hover
        ref="selectableTable"
        :items="getInfo"
        :fields="key"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(description.id)="row">
          <div v-html="row.value.substring(0,50)"></div>
        </template>
        <template v-slot:cell(image)="row">
          <b-img :src="row.value" width="75px" rounded alt="Image"></b-img>
        </template>
        <template v-slot:cell(status)="row">
          <p class="text-success" v-if="row.value == 'publish'">Publish</p>
          <p class="text-warning" v-else-if="row.value == 'archive'">Archive</p>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{name: 'editPaxelMarketJoinProcedure', params: {id: item.id}}"
            class="text-dark"
          >
            <img src="@/assets/ic-edit.svg" class="mr-2" alt />
          </router-link>
          <b-link
            v-b-tooltip.hover
            title="Delete"
            class="text-dark"
            @click="del(item.id)"
          >
            <img src="@/assets/rectangle.svg" class="mr-2" alt />
          </b-link>
          <b-link
            v-b-tooltip.hover
            title="Up Order"
            :class="{'order-link':item.order_field === 1}"
            @click="orderJoinProcedure({id:item.id,change:'up'})"
            class="text-primary"
          >
            <i class="fas fa-arrow-up mr-2"></i>
          </b-link>
          <b-link
            v-b-tooltip.hover
            title="Down Order"
            :class="{'order-link':item.order_field == totalRows}"
            @click="orderJoinProcedure({id:item.id,change:'down'})"
            class="text-primary"
          >
            <i class="fas fa-arrow-down"></i>
          </b-link>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{totalRows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      errored: false,
      items: [],
      key: [
        {
          key: "title.id",
          label: "Title",
          sortable: true,
          class: "text-center"
        },
        {
          key: "description.id",
          label: "Description",
          sortable: true,
          class: "text-center"
        },
        {
          key: "image",
          label: "Image",
          sortable: true,
          class: "text-center"
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          class: "text-center"
        },
        { key: "action", label: "Action", class: "text-center" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: "",
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
    }
  },
  methods: {
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      this.$store
          .dispatch("PaxelMarketJoinProcedureModule/getJoinProcedures", formData)
          .then((response) => {
            vm.totalRows = response.data.data.total_record;
            callback(response.data.data.results || []);
            this.loading = false;
          })
          .catch((error) => {
            this.isBusy = false;
            callback([]);
          });
        return null;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    orderJoinProcedure(order) {
      this.loading = true;
      const orderData = {
        change_type: order.change,
      };
      this.$store
        .dispatch("PaxelMarketJoinProcedureModule/orderJoinProcedure", {
          id: order.id,
          orderData,
        })
        .then((response) => {
          this.$refs.selectableTable.refresh();
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(response);
        })
        .catch((error) => {
          this.loading = false;
          this.serverError = error.response.data;
          console.log(error);
        });
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("PaxelMarketJoinProcedureModule/delJoinProcedure", id)
          .then((response) => {
            this.$refs.selectableTable.refresh();
            this.$swal("Deleted!", "Your data has been deleted.", "success");
          })
          .catch((error) => {
            this.loading = false;
            this.serverError = error.response.data;
            console.log(error);
            this.$swal("Failed to Delete!", "Your data has not been deleted.", "error");
          });
        }
      });
    },
  }
};
</script>

<style>
</style>